const chartsStyle = {
	title: {
		color: "red",
	},
	dateTimeWrapper: {
		'& .rdtPicker': {
			top: '65px',
			zIndex: 10
		},
	},
	actionContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
	},
	detailsContainer: {
		width: '100% !important',
		margin: '0 !important',
	},
	formContainer: {
		minHeight: '400px',
	}
};

export default chartsStyle;
